// cartState.ts
import { makeVar } from '@apollo/client'

import { Currency } from '../types/currency'

export const totalQuantityVar = makeVar<number>(
  Number(localStorage.getItem('totalQuantity')) || 0
)
export type CartDetails = {
  channelID: string
  channelCode: string
  channelName: string
  propertyCode: string
  currrncy: Currency
}

export const cartDetailsVar = makeVar<CartDetails>({
  channelID: '',
  channelCode: '',
  channelName: '',
  propertyCode: '',
  currrncy: ''
})
